import styled from "styled-components";
import { Navbar } from "react-bootstrap";

export const StyledNavbar = styled(Navbar)`
  font-family: "Poppins";
  font-weight: 600;
  color: #fff;
`;
